import { RECENTLY_VIEWED_KEY } from "@jky/events";
import { readData, storeData, fetchHtml } from "@jky/utilities";
import { Component } from '@jky/component';

customElements.get("recently-viewed-products") || customElements.define("recently-viewed-products", class extends Component {
    constructor() {
        super();
        this.productIds = [];
        this.initialized = false;
        this.renderedIndex = 0;
        this.swiperClass = ".recently-viewed--swiper";
        this.containerClass = ".recently-viewed-container";
    }
    connectedCallback() {
        super.connectedCallback();
        this.loop = true;
        this.limit = parseInt(this.dataset.limit) || 10;
        this.productIds = readData(RECENTLY_VIEWED_KEY)?.slice(-this.limit)?.reverse() ?? [];
        if (!this.productIds || this.productIds.length <= 0) return this.remove();
        this.fetchRender();
    }
    fetchRender() {
        const url = this.constructQueryUrl();
        fetchHtml(url).then(html => {
            const targetElement = this.querySelector(this.containerClass);
            const sourceElement = html.querySelector(this.containerClass);
            if (targetElement && sourceElement) {
                const fragment = document.createDocumentFragment();
                this.productIds.forEach(id => {
                    const item = sourceElement.querySelector(`.swiper-slide[data-id="${id}"]`);
                    item && fragment.appendChild(item);
                })
                targetElement.innerHTML = "";
                targetElement.appendChild(fragment);
                this.loop = targetElement.querySelectorAll(".swiper-slide").length > 1;
                setTimeout(() => {
                    this.initSwiper();
                    this.initialized = true;
                    this.classList.remove("skeleton");
                }, 20);
                return;
            }
            this.remove();
        })
    }

    initSwiper() {
        this.swiper = new Swiper(this.swiperClass, {
            spaceBetween: 12,
            slidesPerView: 1.2,
            loop: this.loop,
            roundLengths: true,
            breakpoints: {
                1024: {
                    spaceBetween: 12
                }
            }
        });
    }
    constructQueryUrl() {
        const baseUrl = this.dataset.searchUrl
          , query = this.productIds.map(id => `id:${id}`).join(" OR ")
          , params = new URLSearchParams({
            q: query,
            type: "product",
            section_id: 'jky-recently-viewed-card',
            ose: "false"
        });
        return `${baseUrl}?${params.toString()}`
    }
})